import {
  DarkTheme,
  DefaultTheme,
  ThemeProvider,
} from "@react-navigation/native";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { useFonts } from "expo-font";
import * as SplashScreen from "expo-splash-screen";
import Constants from "expo-constants";
import { StatusBar } from "expo-status-bar";
import { useEffect } from "react";
import "react-native-reanimated";

import { useColorScheme } from "@/hooks/useColorScheme";
import { store } from "./store";
import { queryClient } from "./config/queryClient";
import RootStackLayout from "./RootStack";
import { VersionUpdateBanner } from "./components/VersionUpdateBanner";
import * as Sentry from "@sentry/react-native";

Sentry.init({
  dsn: Constants.expoConfig?.extra?.sentryDsn,
  sendDefaultPii: true,
  environment: Constants.expoConfig?.extra?.envName,
});

// Prevent the splash screen from auto-hiding before asset loading is complete.
SplashScreen.preventAutoHideAsync();

export default Sentry.wrap(function RootLayout() {
  const colorScheme = useColorScheme();
  const [loaded] = useFonts({
    SpaceMono: require("../assets/fonts/SpaceMono-Regular.ttf"),
    HelveticaNeue: require("../assets/fonts/HelveticaNeue.otf"),
    "HelveticaNeue-Medium": require("../assets/fonts/HelveticaNeue-Medium.otf"),
  });

  useEffect(() => {
    if (loaded) {
      SplashScreen.hideAsync();
    }
  }, [loaded]);

  if (!loaded) {
    return null;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ThemeProvider
          value={colorScheme === "dark" ? DarkTheme : DefaultTheme}
        >
          <VersionUpdateBanner />
          <RootStackLayout />
          <StatusBar style="auto" />
        </ThemeProvider>
      </Provider>
    </QueryClientProvider>
  );
});
